import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'hero' | 'cta';
  className?: string;
  id?: string;
  as?: keyof JSX.IntrinsicElements;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Section: React.FC<SectionProps> = ({
  children,
  variant = 'primary',
  className = '',
  id,
  as: Component = 'section',
  size = 'lg'
}) => {
  const baseClasses = 'w-full';
  
  const variantClasses = {
    primary: 'bg-white dark:bg-gray-900',
    secondary: 'bg-gray-50 dark:bg-gray-800', 
    tertiary: 'bg-gray-100 dark:bg-gray-700',
    hero: 'bg-[var(--premium-accent-cta,#0070f3)] text-white',
    cta: 'bg-[var(--premium-accent-cta,#0070f3)] text-white'
  };

  const sizeClasses = {
    sm: 'py-8 lg:py-12',
    md: 'py-12 lg:py-16', 
    lg: 'py-16 lg:py-20',
    xl: 'py-20 lg:py-24'
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <Component id={id} className={combinedClasses}>
      <div className="container mx-auto px-4">
        {children}
      </div>
    </Component>
  );
};

// Named export for Vite's code splitting
export { Section };
export type { SectionProps };
export default Section;